import { createIcon } from "app/icons/createIcon";
import _AviosQatarIcon from "./AviosQatarIcon";
import _AwardFilledIcon from "./AwardFilledIcon";
import _AwardFlightFilledIcon from "./AwardFlightFilledIcon";
import _AwardFlightStrokeIcon from "./AwardFlightStrokeIcon";
import _AwardStrokeIcon from "./AwardStrokeIcon";
import _BaggageValidatedFilledIcon from "./BaggageValidatedFilledIcon";
import _BaggageValidatedStrokeIcon from "./BaggageValidatedStrokeIcon";
import _CashbackEuroIcon from "./CashbackEuroIcon";
import _CoinsFilledIcon from "./CoinsFilledIcon";
import _CoinsStarFilledIcon from "./CoinsStarFilledIcon";
import _CoinsStarStrokeIcon from "./CoinsStarStrokeIcon";
import _CoinsStrokeIcon from "./CoinsStrokeIcon";
import _CreditCardFilledIcon from "./CreditCardFilledIcon";
import _CreditCardsFilledIcon from "./CreditCardsFilledIcon";
import _CreditCardsStrokeIcon from "./CreditCardsStrokeIcon";
import _CreditCardStrokeIcon from "./CreditCardStrokeIcon";
import _CreditCardValidationFilledIcon from "./CreditCardValidationFilledIcon";
import _CreditCardValidationStrokeIcon from "./CreditCardValidationStrokeIcon";
import _EarnAirIndiaIcon from "./EarnAirIndiaIcon";
import _FileFilledIcon from "./FileFilledIcon";
import _FileNotifFilledIcon from "./FileNotifFilledIcon";
import _FileNotifStrokeIcon from "./FileNotifStrokeIcon";
import _FileStrokeIcon from "./FileStrokeIcon";
import _Flag02FilledIcon from "./Flag02FilledIcon";
import _Flag02StrokeIcon from "./Flag02StrokeIcon";
import _LifebuoyFilledIcon from "./LifebuoyFilledIcon";
import _LifebuoyStrokeIcon from "./LifebuoyStrokeIcon";
import _LightningFilledIcon from "./LightningFilledIcon";
import _LightningStrokeIcon from "./LightningStrokeIcon";
import _MailCheckedFilledIcon from "./MailCheckedFilledIcon";
import _MailCheckedStrokeIcon from "./MailCheckedStrokeIcon";
import _MeasureFilledIcon from "./MeasureFilledIcon";
import _MeasureStrokeIcon from "./MeasureStrokeIcon";
import _MilesFilledIcon from "./MilesFilledIcon";
import _MilesIcon from "./MilesIcon";
import _MilesStrokeIcon from "./MilesStrokeIcon";
import _MoneyBagCircleFilledIcon from "./MoneyBagCircleFilledIcon";
import _MoneyBagCircleStrokeIcon from "./MoneyBagCircleStrokeIcon";
import _MoneyBagFilledIcon from "./MoneyBagFilledIcon";
import _MoneyBagStrokeIcon from "./MoneyBagStrokeIcon";
import _MoonFilledIcon from "./MoonFilledIcon";
import _MoonStrokeIcon from "./MoonStrokeIcon";
import _PdfFilledIcon from "./PdfFilledIcon";
import _PdfNotificationFilledIcon from "./PdfNotificationFilledIcon";
import _PdfNotificationStrokeIcon from "./PdfNotificationStrokeIcon";
import _PdfStrokeIcon from "./PdfStrokeIcon";
import _PercentSquareFilledIcon from "./PercentSquareFilledIcon";
import _PercentSquareStrokeIcon from "./PercentSquareStrokeIcon";
import _PointsAirIndiaIcon from "./PointsAirIndiaIcon";
import _PromoIcon from "./PromoIcon";
import _StarCircleIcon from "./StarCircleIcon";
import _StarFilledIcon from "./StarFilledIcon";
import _StarStrokeIcon from "./StarStrokeIcon";
import _TagFilledIcon from "./TagFilledIcon";
import _TagStrokeIcon from "./TagStrokeIcon";
import _TicketFilledIcon from "./TicketFilledIcon";
import _TicketStrokeIcon from "./TicketStrokeIcon";
import _TimerFilledIcon from "./TimerFilledIcon";
import _TimerStrokeIcon from "./TimerStrokeIcon";

export const AviosQatarIcon = createIcon(_AviosQatarIcon);
export const AwardFilledIcon = createIcon(_AwardFilledIcon);
export const AwardFlightFilledIcon = createIcon(_AwardFlightFilledIcon);
export const AwardFlightStrokeIcon = createIcon(_AwardFlightStrokeIcon);
export const AwardStrokeIcon = createIcon(_AwardStrokeIcon);
export const BaggageValidatedFilledIcon = createIcon(_BaggageValidatedFilledIcon);
export const BaggageValidatedStrokeIcon = createIcon(_BaggageValidatedStrokeIcon);
export const CashbackEuroIcon = createIcon(_CashbackEuroIcon);
export const CoinsFilledIcon = createIcon(_CoinsFilledIcon);
export const CoinsStarFilledIcon = createIcon(_CoinsStarFilledIcon);
export const CoinsStarStrokeIcon = createIcon(_CoinsStarStrokeIcon);
export const CoinsStrokeIcon = createIcon(_CoinsStrokeIcon);
export const CreditCardFilledIcon = createIcon(_CreditCardFilledIcon);
export const CreditCardsFilledIcon = createIcon(_CreditCardsFilledIcon);
export const CreditCardsStrokeIcon = createIcon(_CreditCardsStrokeIcon);
export const CreditCardStrokeIcon = createIcon(_CreditCardStrokeIcon);
export const CreditCardValidationFilledIcon = createIcon(_CreditCardValidationFilledIcon);
export const CreditCardValidationStrokeIcon = createIcon(_CreditCardValidationStrokeIcon);
export const EarnAirIndiaIcon = createIcon(_EarnAirIndiaIcon);
export const FileFilledIcon = createIcon(_FileFilledIcon);
export const FileNotifFilledIcon = createIcon(_FileNotifFilledIcon);
export const FileNotifStrokeIcon = createIcon(_FileNotifStrokeIcon);
export const FileStrokeIcon = createIcon(_FileStrokeIcon);
export const Flag02FilledIcon = createIcon(_Flag02FilledIcon);
export const Flag02StrokeIcon = createIcon(_Flag02StrokeIcon);
export const LifebuoyFilledIcon = createIcon(_LifebuoyFilledIcon);
export const LifebuoyStrokeIcon = createIcon(_LifebuoyStrokeIcon);
export const LightningFilledIcon = createIcon(_LightningFilledIcon);
export const LightningStrokeIcon = createIcon(_LightningStrokeIcon);
export const MailCheckedFilledIcon = createIcon(_MailCheckedFilledIcon);
export const MailCheckedStrokeIcon = createIcon(_MailCheckedStrokeIcon);
export const MeasureFilledIcon = createIcon(_MeasureFilledIcon);
export const MeasureStrokeIcon = createIcon(_MeasureStrokeIcon);
export const MilesFilledIcon = createIcon(_MilesFilledIcon);
export const MilesIcon = createIcon(_MilesIcon);
export const MilesStrokeIcon = createIcon(_MilesStrokeIcon);
export const MoneyBagCircleFilledIcon = createIcon(_MoneyBagCircleFilledIcon);
export const MoneyBagCircleStrokeIcon = createIcon(_MoneyBagCircleStrokeIcon);
export const MoneyBagFilledIcon = createIcon(_MoneyBagFilledIcon);
export const MoneyBagStrokeIcon = createIcon(_MoneyBagStrokeIcon);
export const MoonFilledIcon = createIcon(_MoonFilledIcon);
export const MoonStrokeIcon = createIcon(_MoonStrokeIcon);
export const PdfFilledIcon = createIcon(_PdfFilledIcon);
export const PdfNotificationFilledIcon = createIcon(_PdfNotificationFilledIcon);
export const PdfNotificationStrokeIcon = createIcon(_PdfNotificationStrokeIcon);
export const PdfStrokeIcon = createIcon(_PdfStrokeIcon);
export const PercentSquareFilledIcon = createIcon(_PercentSquareFilledIcon);
export const PercentSquareStrokeIcon = createIcon(_PercentSquareStrokeIcon);
export const PointsAirIndiaIcon = createIcon(_PointsAirIndiaIcon);
export const PromoIcon = createIcon(_PromoIcon);
export const StarCircleIcon = createIcon(_StarCircleIcon);
export const StarFilledIcon = createIcon(_StarFilledIcon);
export const StarStrokeIcon = createIcon(_StarStrokeIcon);
export const TagFilledIcon = createIcon(_TagFilledIcon);
export const TagStrokeIcon = createIcon(_TagStrokeIcon);
export const TicketFilledIcon = createIcon(_TicketFilledIcon);
export const TicketStrokeIcon = createIcon(_TicketStrokeIcon);
export const TimerFilledIcon = createIcon(_TimerFilledIcon);
export const TimerStrokeIcon = createIcon(_TimerStrokeIcon);
